export async function fetchClipMetadata(getToken, { fileStem, clipFilename, generate = false, field = 'all' }) {
  const token = await getToken();
  if (!token) throw new Error('Please sign in again.');

  const params = new URLSearchParams({
    file_stem: fileStem,
    clip_filename: clipFilename,
  });
  if (generate) {
    params.set('generate', '1');
  }
  if (field && field !== 'all') {
    params.set('field', field);
  }

  const res = await fetch(`/api/schedule/clip-metadata?${params}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || 'Could not load clip details.');
  }
  return data.metadata || {};
}
